<template>
  <div :class="['upload-img', `${page_style}`]">
    <div
      :class="['status-wrap', {'ing': isIng}, {'success': isSuccess}, {'fail': isFailed}]"
      v-if="!isNew && field_result">
      <p>{{field_result}}</p>
    </div>
    <div class="content-wrapper">
      <div class="upload-img-header" @click="showScale()" v-if="pics.length">
        <img-v3 :src="pics[0]" :class="{widthImg:pic_type==1,heightImg:pic_type==2}" />
      </div>
      <div class="upload-img-content">
        <p class="content-title">{{sample.title}}</p>
        <div class="photos">
        <div v-for="(p, i) in pic_field" :key="i">
          <p>{{p.title}}</p>
          <div class="img-wraper">
            <div v-for="(v,index) in p.show_value" class="imgs" :key="index">
              <img-v3 :src="pdf_re.test(v)?pdf_pic:v" @click="showScale(v)" />
              <div v-if="!hideBottom" class="close" @click="removeImg(p,index)">x</div>
            </div>
            <div class="add-pic" v-show="(p.value || []).length<p.max_pic_num && !hideBottom">
              +
              <template v-if="inApp">
                <input type="button" @click="selectImg(p)" />
              </template>
              <template v-else>
                <input v-if="formItem.limit_status" id="photo" type="file" accept="image/*" capture="camera">
                <input v-else class="input_photo" type="file" accept="image/*" @click="outFileChoose(p)" />
              </template>
            </div>
          </div>
        </div>
      </div>
        <div class="content-p-wrapper">
          <p class="content-p" v-for="(t,idx) in sample.content" :key="idx" v-html="t" @click="richTextClick($event)"></p>
        </div>
      </div>
    </div>
    <div class="upload-input-wrapper" v-if="!hideBottom">
      <p class="declare" @click="declareClick" v-if="declare.desc_title">
        <i :class="{active:aggre,agreed:field_status!=0&&field_status!=6}"></i>
        {{declare.desc_title}}
      </p>
      <div
        :class="{'multi-upload-input':1,'multi-upload-input-active':valid}"
        @click="submitImg"
      >{{$t('img.submit_btn_txt')}}</div>
    </div>
    <!-- <load-link :src="uploadImgSrc" :show="show_link" @close="closePdf"></load-link> -->
    <scale ref="scaleRef" :img-url="exampleImg"></scale>
  </div>
</template>

<script>
import { mapState } from "vuex";
import scale from "./Scale";
import loadLink from "./load-link";
import { imgCompress } from "../../tools/utils";
import { post } from "../../tools/request";
import { showLoadingToast, showAlertDialog } from "../../tools/Tip";

const AUDIT_STATUS = {
  in: 3,
  success: 4,
  fail: 5,
  noSubmit: 0,
  beforeUpdate: 6
};

export default {
  name: "multi-upload-photo",
  components: { scale, loadLink },
  data() {
    return {
      pdf_pic: require("../../images/PDF@3x.png"),
      pdf_re: /\.pdf$/,
      show_link: false,
      uploadImgSrc: "",
      exampleImg: "",
      aggre: false,
      tempField: {}, //当前处理的图片组--上传用
      uploadStart: 0,
      originSize: 0,
      compressedSize: 0,
      b2md5: null,
      store_result: null
    };
  },
  props: ['dialogStyle', 'auditConfig'],
  computed: {
    ...mapState(["_ticket", "_uuid"]),
    valid() {
      return this.pic_field.every(x => {
        if (this.declare.desc_title) {
          if (!this.aggre) {
            return false;
          } else {
            return x.value.length >= x.min_pic_num;
          }
        } else {
          return x.value.length >= x.min_pic_num;
        }
      });
    },
    AUDIT_STATUS() {
      return AUDIT_STATUS;
    },
    deviceInfo() {
      return {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      };
    },
    page_style() {
      return this.$route.params.page_style || this.dialogStyle;
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    //传递过来整个对象
    formItem() {
      let c = this.isFleetPCFunnel ? this.auditConfig : this.$route.params.configs;
      return c || {};
    },
    declare() {
      return this.formItem.declare || {};
    },
    pics() {
      return this.formItem.exam_pic_url || [];
    },
    pic_type() {
      return this.formItem.exam_pic_type || 1;
    },
    pic_field() {
      return this.formItem.pic_field || [];
    },
    sample() {
      return this.formItem.pic_desc || {};
    },
    field_status() {
      return this.formItem.field_status || 0;
    },
    isNew() {
      return this.field_status == AUDIT_STATUS.noSubmit || this.field_status == AUDIT_STATUS.beforeUpdate;
    },
    isIng() {
      return this.field_status == AUDIT_STATUS.in;
    },
    isSuccess() {
      return this.field_status == AUDIT_STATUS.success;
    },
    isFailed() {
      return this.formItem.field_status == AUDIT_STATUS.fail;
    },
    field_result() {
      return this.formItem.field_result || "";
    },
    //上传成功态，隐藏底部按钮
    hideBottom() {
      return this.field_status == AUDIT_STATUS.success;
    },
    inApp() {
      return !!Fusion.pickImage;
    },
    hasChooseImage() {
      return !!Fusion.chooseImage;
    },
    document_enum() {
      return this.formItem.document_enum || "";
    }
  },

  beforeCreate() {
    //一旦进入上传页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  created() {
    //展示项赋初始值
    // (this.formItem.pic_field || []).forEach(x => {
    //   x.show_value = JSON.parse(JSON.stringify(x.value));
    // });
    // @20190522新增逻辑，agree同意过之后，再次进入保持状态
    if (this.field_status != 0 && this.field_status != 6) {
      this.aggre = true;
    }
  },
  mounted() {
    this.initOutUpload();
  },
  methods: {
    showScale(src) {
      this.exampleImg = src || this.pics[0];
      this.$refs.scaleRef.show();
    },
    initOutUpload() {
      //端外使用input上传
      if (!this.inApp) {
        const photoBtn = document.getElementsByClassName("input_photo");
        for (let d of photoBtn) {
          imgCompress(d, this.handleAfterChoose, this.handleImageError);
        }
      }
    },
    declareClick() {
      if (this.field_status != 0 && this.field_status != 6) {
        return;
      }
      this.aggre = !this.aggre;
      this.$emit("btn-update");
    },
    showPdf(url) {
      return;
      this.show_link = true;
      this.uploadImgSrc = url;
    },
    closePdf() {
      this.show_link = false;
    },
    //采用澳洲方案，先传图片，再提审
    uploadImg() {
      this.uploadStart = +new Date();
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let success = data => {
        this.toast.hide();
        if (data.low_quality_res && data.low_quality_res === 1) {
          showAlertDialog(this, data.low_quality_des);
          return false;
        }
        this.tempField.value.push(data.img_id);
        this.tempField.show_value.push(this.uploadImgSrc);
        this.$emit("btn-update");
        // try {
        //   if (this.b2md5 && !this.store_result) {
        //     //后半段判断，防止多次选择同一图片后，重复的set操作
        //     window.localStorage.setItem(this.b2md5, data.img_id);
        //   }
        // } catch (e) {}
        Omega.trackEvent("upload_success", "", {
          duid: this._uuid,
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          origin_size: this.originSize,
          compressed_size: this.compressedSize
        });
      };
      up.append("__x_img", this.uploadImgSrc);
      up.append("type", this.tempField.key);
      up.append("document_enum", this.document_enum);

      post(process.env.UPLOAD_IMG, up)
        .then(success)
        .catch(this.httpError);
    },
    submitImg() {
      if (!this.valid) {
        return;
      }
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      this.pic_field.forEach(x => {
        up.append(x.key, JSON.stringify(x.value));
      });
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      // @20210419 多种类型上传组件, 外层透传radio选择类型 key,value
      if (this.formItem.radio_type_key) {
        up.append(this.formItem.radio_type_key, this.formItem.radio_type_value);
      }
      // @20190213 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }
      let success = data => {
        this.toast.hide();
        let isHistory = this.$route.params.page_route && this.$route.params.page_route == 'history';
        this.$router.replace({ name: isHistory ? "history" : 'home' });
      };
      post(process.env.ADD_AUDI_INFO, up)
        .then(success)
        .catch(err => {
          this.httpError(err);
          try {
            Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
              path_url: process.env.ADD_AUDI_INFO,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        });
    },
    selectImg(p, idx) {
      this.tempField = p;
      
      // Fusion.pickImage(
      //   {
      //     width:'1500',
      //     height: '1500'
      //   },
      //   ret => this.handleAfterChoose(ret)
      // );
      if (this.hasChooseImage) {
        Fusion.chooseImage(
          {
            source: this.formItem.limit_status ? 2 : 3,
            quailty: 100,
            width: 1500,
            height: 1500,
          },
          (ret) => this.handleAfterChoose(ret)
        );
      } else {
        Fusion.pickImage(
          {
            width:'1500',
            height: '1500',
            source: this.formItem.limit_status ? 2 : 3,
          },
          ret => this.handleAfterChoose(ret)
        );
      }

    },
    handleAfterChoose(ret) {
      let imgSrc
      if (this.inApp && this.hasChooseImage) {
        if (!ret) {
          return;
        }
        imgSrc = "data:image/jpeg" + ";base64," + ret.image;
      } else {
        if (ret.errorCode != 104) {
          return
        }
        imgSrc = ret.imageBase64String;
        if (this.inApp) {
          imgSrc = "data:image/jpeg" + ";base64," + ret.imageBase64String;
        }
      }
      // if (!ret) {
      //   return;
      // }
      // // let imgSrc = ret.imageBase64String;
      // let imgSrc = ret.image;
      // if (this.inApp) {
      //   imgSrc = "data:image/jpeg" + ";base64," + ret.image;
      // }
      // try {
      //   if (window.localStorage) {
      //     this.b2md5 = md5(imgSrc);
      //     this.store_result = window.localStorage.getItem(this.b2md5);
      //     if (this.store_result) {
      //       Omega.trackEvent("hit_img_cache", "", {
      //         duid: this._uuid,
      //         app_upload: this.inApp
      //       });
      //     }
      //   }
      // } catch (e) {}
      //埋点用
      this.compressedSize = imgSrc.length;
      this.originSize = ret.originSize || 0;
      this.uploadImgSrc = imgSrc;
      this.uploadImg();
    },
    handleImageError() {
      showAlertDialog(this, this.$t("图片尺寸过大"));
    },
    httpError(err) {
      try {
        Omega.trackEvent("upload_fail", "", {
          duid: this._uuid,
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          origin_size: this.originSize,
          compressed_size: this.compressedSize,
          msg: err.errmsg || err.message
        });
      } catch (e) {}
      this.toast.hide();
      showAlertDialog(this, err.errmsg || this.$t("ERROR_DEFAULT_TEXT"));
    },
    //移除图片
    removeImg(item, idx) {
      item.value.splice(idx, 1);
      item.show_value.splice(idx, 1);
      this.$emit("btn-update");
    },
    outFileChoose(p, idx) {
      document.querySelector('.input_photo').value = '';
      this.tempField = p;
    },
    richTextClick(event) {
      if(event.target.nodeName === 'A' && event.target.getAttribute('data-w-e-type')){
        event.preventDefault();
        const download_url = event.target.href;
        // 获取触发事件对象的属性
        if (!!Fusion.openPage) {
          Fusion.openPage && Fusion.openPage({
            url: download_url,
            newWindow: true,
            target: "native",
            browser: true
          });
        } else {
          window.open(download_url, "_blank");
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.upload-img {
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 2.5rem;
  .status-wrap {
    padding: 0.36rem 0.3rem;
    color: #fff;
    font-size: 0.32rem;
    position: fixed;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 100%;
    opacity: 0.9;
    z-index: 1;
    &.ing {
      background: #91A0B4;
    }
    &.success {
      background: #18C47C;
    }
    &.fail{
      background: #FF525D;
    }
  }
  .upload-img-header {
    height: 6.12rem;
    background: #282a33;
    overflow: hidden;
    position: relative;
    .widthImg {
      width: 6rem;
      height: 5.18rem;
      background-size: 6rem 5.18rem;
    }
    .heightImg {
      width: 3.84rem;
      height: 5.2rem;
      background-size: 3.84rem 5.2rem;
    }
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .upload-img-content {
    text-align: center;
    padding: 0.3rem 0.32rem 0;
    .content-title {
      font-size: 0.48rem;
      color: #1f2933;
      margin-bottom: 0.24rem;
    }
    .content-p {
      text-align: left;
      font-size: 0.28rem;
      color: #949494;
      margin-bottom: 0.2rem;
      line-height: 1.1;
    }
  }
  .photos {
    // padding: 0.3rem 0.32rem 0;
    text-align: left;
    font-size: 0.3rem;
    color: #949494;
    .img-wraper {
      display: flex;
      flex-wrap: wrap;
      & > div {
        width: 2rem;
        height: 2rem;
        margin: 0.2rem 0.26rem 0.2rem 0;
      }

      img {
        width: 100%;
        height: 100%;
      }
      .imgs {
        position: relative;
        .close {
          position: absolute;
          right: -0.15rem;
          top: -0.18rem;
          color: #fff;
          background: #afb0b3;
          width: 0.46rem;
          height: 0.46rem;
          text-align: center;
          line-height: 0.4rem;
          border-radius: 50%;
        }
      }
      .add-pic {
        position: relative;
        font-size: 1rem;
        line-height: 1.8rem;
        color: #d8d8d8;
        text-align: center;
        background: #fff;
        input {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
    }
  }
  .upload-input-wrapper {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    background: #f5f5f7;
    .declare {
      padding: 0.3rem 0.32rem 0;
      font-weight: bold;
      font-size: 0.28rem;
      color: #949494;
      i {
        display: inline-block;
        vertical-align: middle;
        width: 0.28rem;
        height: 0.28rem;
        background-size: 0.28rem;
        background-image: url(../../images/icon-unchecked@3x.png);
      }
      .active {
        background-image: url(../../images/icon-checked@3x.png);
      }
      .agreed {
        background-image: url(../../images/icon-uploaded@3x.png);
      }
    }
    .multi-upload-input {
      position: relative;
      margin: 0.4rem auto;
    }
  }
  &.h5_funnel_fleet,
  &.h5_funnel_fleet_pc {
    padding-bottom: 2rem;
    background: #ffffff;
    .upload-img-header {
      height: 4.64rem;
      background: #ffffff;
      .widthImg {
        max-width: 80%;
        max-height: 80%;
        width: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .upload-img-content {
      padding-top: 0;
      .content-title {
        margin-bottom: 0.32rem;
        line-height: 0.44rem;
        font-size: .36rem;
        color: #333333;
        font-weight: 700;
      }
      .content-p-wrapper {
        padding: 0.32rem;
        background: #FAFAFA;
        border-radius: .12rem;
        .content-p {
          font-size: .28rem;
          color: #999999;
          line-height: .4rem;
          font-weight: 400;
        }
      }
    }
    .photos {
      padding: 0;
      .img-wraper .add-pic {
        border: 1px solid rgba(216,216,216,1);
        border-radius: 4px;
      }
    }
    .upload-input-wrapper {
      background: #ffffff;
      box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.06);
      .out-upload-input {
        border-radius: .2rem;
        font-weight: 700;
        font-size: 0.4rem;
        &.mx-submit {
          background-image: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
        }
      }
    }
  }
  &.h5_funnel_fleet_pc {
    padding-bottom: 80px;
    .upload-img-header {
      height: 180px;
      padding: 16px 0 32px 0;
      .examImg {
        max-width: 80%;
        max-height: 100%;
      }
    }
    .upload-img-content {
      padding: 0 40px;
      .content-title {
        margin-bottom: 16px;
        font-size: 18px;
        text-align: center;
        line-height: 22px;
        font-weight: 700;
      }
      .content-p-wrapper {
        margin-top: 8px;
        padding: 16px;
        border-radius: 6px;
        .content-p {
          font-size: 14px;
          line-height: 20px;
          font-weight: 400;
        }
      }
    }
    .photos {
      p {
        font-size: 14px;
      }
      .img-wraper {
        & > div {
          width: 95px;
          height: 95px;
          margin: 8px 12px 8px 0;
        }
      }
      .add-pic {
        line-height: 85px;
      }
      .img-wraper .imgs .close {
        width: 18px;
        height: 18px;
        font-size: 14px;
        line-height: 16px;
      }
    }
    .upload-input-wrapper {
      display: inline-block;
      position: absolute;
      height: 80px;
      padding: 24px;
      box-shadow: none;
      text-align: right;
      .multi-upload-input {
        width: auto;
        display: inline-block;
        margin: 0;
        padding: 6px 16px;
        box-sizing: border-box;
        height: 32px;
        line-height: 20px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
        color: #fff;
        background-color: #E9ECEE;
        color: #999999;
      }
      .multi-upload-input-active {
        background-image: linear-gradient(-45deg, #FFAE1E 0%, #FFCA00 100%);
        color: #333333;
      }
    }
  }
}
</style>
